module.exports = __webpack_public_path__ + "static/media/accessory5.624c2eb2.webp";